module.exports = __webpack_public_path__ + "img/Group 970one.1304107e.png";